/**
 * @author  x521320930@gmail.com
 * @version 1.0 | 2017-10-11
 * @describe  存放各种API请求
 * @example
 */
import * as apiList from './list/apiList'

export default {
  ...apiList
}



// WEBPACK FOOTER //
// ./src/api/index.js